module.exports = __webpack_public_path__ + "img/machine-code-guide1.1e0527ef.png";